import { createSvgIcon } from '@mui/material';

export const ApplePayIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    // width='53'
    // height='41'
    // viewBox='0 0 53 41'
    width='46'
    height='30'
    viewBox='0 0 46 30'
    fill='none'
  >
    <g filter='url(#filter0_dd_19685_71159)'>
      <rect
        x='8'
        y='4.72412'
        width='37.25'
        height='24.5521'
        rx='4.29851'
        fill='#EDEDED'
      />
      <rect
        x='7.91045'
        y='4.63457'
        width='37.4291'
        height='24.7312'
        rx='4.38806'
        stroke='#D6DCE5'
        strokeWidth='0.179104'
      />
      <path
        d='M19.2937 13.2896C19.5712 12.9424 19.7595 12.4763 19.7099 12C19.3036 12.0202 18.8078 12.268 18.5208 12.6154C18.263 12.913 18.0349 13.3986 18.0944 13.8549C18.5505 13.8945 19.0061 13.627 19.2937 13.2896Z'
        fill='#000008'
      />
      <path
        d='M19.7047 13.944C19.0424 13.9046 18.4792 14.3199 18.1629 14.3199C17.8465 14.3199 17.3621 13.9639 16.8383 13.9735C16.1564 13.9835 15.5238 14.369 15.1778 14.9822C14.4661 16.2088 14.99 18.0283 15.682 19.0273C16.0181 19.5215 16.4231 20.0657 16.9568 20.0462C17.4611 20.0264 17.6587 19.7196 18.2717 19.7196C18.8842 19.7196 19.0622 20.0462 19.596 20.0363C20.1495 20.0264 20.4956 19.5418 20.8317 19.0471C21.2172 18.4837 21.375 17.9396 21.385 17.9098C21.375 17.8999 20.3176 17.4942 20.3078 16.2778C20.2978 15.2593 21.138 14.7748 21.1775 14.7448C20.7031 14.043 19.9617 13.9639 19.7047 13.944Z'
        fill='#000008'
      />
      <path
        d='M25.4716 12.5656C26.9112 12.5656 27.9136 13.5579 27.9136 15.0026C27.9136 16.4525 26.8906 17.4499 25.4355 17.4499H23.8417V19.9846H22.6901V12.5656L25.4716 12.5656ZM23.8417 16.4833H25.163C26.1656 16.4833 26.7363 15.9435 26.7363 15.0078C26.7363 14.0721 26.1656 13.5374 25.1682 13.5374H23.8417V16.4833Z'
        fill='#000008'
      />
      <path
        d='M28.2144 18.4474C28.2144 17.5013 28.9394 16.9203 30.2248 16.8483L31.7054 16.761V16.3446C31.7054 15.743 31.2992 15.3831 30.6207 15.3831C29.9779 15.3831 29.5768 15.6915 29.4793 16.1749H28.4304C28.4921 15.198 29.3249 14.4782 30.6617 14.4782C31.9728 14.4782 32.8107 15.1723 32.8107 16.2571V19.9846H31.7465V19.0951H31.7209C31.4073 19.6967 30.7234 20.0771 30.014 20.0771C28.9548 20.0771 28.2144 19.419 28.2144 18.4474ZM31.7054 17.9589V17.5322L30.3738 17.6144C29.7105 17.6607 29.3353 17.9538 29.3353 18.4165C29.3353 18.8895 29.726 19.198 30.3224 19.198C31.0987 19.198 31.7054 18.6632 31.7054 17.9589Z'
        fill='#000008'
      />
      <path
        d='M33.8155 21.9743V21.0746C33.8976 21.0951 34.0827 21.0951 34.1753 21.0951C34.6894 21.0951 34.9671 20.8792 35.1367 20.3239C35.1367 20.3136 35.2344 19.9949 35.2344 19.9897L33.2808 14.5759H34.4837L35.8515 18.9769H35.8719L37.2396 14.5759H38.4118L36.386 20.2673C35.9235 21.5784 35.3888 22 34.2679 22C34.1753 22 33.8976 21.9897 33.8155 21.9743Z'
        fill='#000008'
      />
    </g>
    <defs>
      <filter
        id='filter0_dd_19685_71159'
        x='0.656622'
        y='0.962832'
        width='51.9368'
        height='39.2385'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='0.358209' />
        <feGaussianBlur stdDeviation='1.79104' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_19685_71159'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3.58209' />
        <feGaussianBlur stdDeviation='3.58209' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_19685_71159'
          result='effect2_dropShadow_19685_71159'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_19685_71159'
          result='shape'
        />
      </filter>
    </defs>
  </svg>,
  'ApplePayIcon',
);
